export function ShieldSecurity({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.00339 2.05176C8.19312 2.05176 8.34724 2.0788 8.43015 2.1084V2.10938L12.0932 3.48047V3.48145C12.274 3.55041 12.4785 3.71159 12.6401 3.94629C12.8018 4.1812 12.8781 4.42808 12.8764 4.62012V10.0264C12.8764 10.1486 12.8314 10.3448 12.7251 10.5576C12.6187 10.7704 12.4879 10.9258 12.3882 11.001L8.72409 13.7393L8.72214 13.7412C8.5513 13.8696 8.29095 13.9551 7.99655 13.9551C7.70211 13.9551 7.44178 13.8697 7.27097 13.7412L7.26901 13.7393L3.60202 10.999L3.59909 10.9971L3.52292 10.9297C3.4418 10.8477 3.34921 10.7223 3.26901 10.5615C3.16247 10.3478 3.11667 10.1493 3.11667 10.0264V4.62695C3.11667 4.43242 3.19486 4.18342 3.35788 3.94824C3.52033 3.71391 3.72598 3.55227 3.90964 3.48242L7.57565 2.1084C7.65838 2.07869 7.81304 2.05176 8.00339 2.05176ZM8.00046 4.58301C6.66627 4.58301 5.58351 5.66583 5.58347 7C5.58347 7.87668 6.05612 8.63598 6.75046 9.05664V10.333C6.75046 11.0206 7.31291 11.583 8.00046 11.583C8.6878 11.5828 9.25046 11.0204 9.25046 10.333V9.05664C9.94344 8.6378 10.4165 7.88284 10.4165 7C10.4164 5.66598 9.33443 4.58325 8.00046 4.58301Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
